export class BrandMonthConversion {
  id: number;
  brandId: number;
  campaignTypeId: number;
  campaignTypeName: string;
  fromMonth: number;
  toMonth: number;
  convertMonth: number;
}
